
import Vue from 'vue'
import { DatePicker } from '@/components/input'

export default Vue.extend({
   props: {
      id: String,
      value: [Date, String],
      label: String,
      start: Date,
      end: Date,
      required: { type: Boolean, default: false },
      readonly: { type: Boolean, default: false },
      view: { type: String, default: 'd' },
   },
   data() {
      return {
         innerValue: null as Date | string | null,
         initialValue: null as Date | string | null,
         dirty: false,
      }
   },
   computed: {
      validationFailed(): boolean {
         if (!this.dirty) {
            return false
         }
         if (!this.required) {
            return false
         }
         return this.innerValue === null
      },

      helpBlock(): string {
         return `A value for ${this.label} is required`
      },
   },
   mounted() {
      this.innerValue = this.value
      this.initialValue = this.value
   },
   watch: {
      value(newValue: Date) {
         if (newValue !== this.innerValue) {
            this.innerValue = newValue
            this.initialValue = newValue
         }
      },
   },
   methods: {
      onChange() {
         if (!this.dirty) {
            this.dirty = this.innerValue !== this.initialValue
         }
         this.$emit('input', this.innerValue)
         this.$emit('change', this.innerValue)
      },
   },
   components: {
      DatePicker,
   },
})
